import { getErrorText } from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest/responseHandlers'
import { ERROR_KEYS } from 'src/dataLayer/remoteData/babbelAPI/requestAuthSessionParams'

import isEmailValid from './isEmailValid'

const onValidEmailSubmit = (parameters, navigate) =>
  parameters.makeAuthSessionRequest().then(
    () => {
      const { passwordPagePath, resetPasswordState } = parameters
      resetPasswordState()
      navigate(passwordPagePath)
    },
    (error) => parameters.setEmailErrorKey(error),
  )

const onInvalidEmailSubmit = ({ setEmailErrorKey }) => {
  const triggeredError = ERROR_KEYS['422']
  setEmailErrorKey(getErrorText(triggeredError))
}

export default (parameters, navigate) =>
  isEmailValid(parameters.email)
    ? onValidEmailSubmit(parameters, navigate)
    : onInvalidEmailSubmit(parameters)
